import {createReducer} from 'topmeteo/utils/redux';
import {findAvailableIndex} from 'topmeteo/utils/image-index';

import {Data, Product} from '../general/actions';
import {initialState as defaultInitialState, reducers as defaultReducers} from '../general/reducer';

const reducers = {
    ...defaultReducers,
    [Product.change]: (state, productID) => ({
        productID,
        canPreload: false,
        isAnimating: false,
        index: findAvailableIndex({index: state.index, productID}, state),
    }),
    [Data.reloaded]: (state, payload) => {
        const values = defaultReducers[Data.reloaded](state, payload);
        const index = findAvailableIndex(payload.isInitial ? values : state, values);

        return {...values, index};
    },
};

export default (initialState, additionalReducers) => createReducer(
    {...defaultInitialState, ...initialState},
    additionalReducers ? {...reducers, ...additionalReducers} : reducers,
);
